<template>
    <div>
        <RequestHistoryLogItem :log="log" v-for="log in logs.data" :key="log.id" />
        <pagination class="mt-3" :data="logs" :limit="10" @pagination-change-page="getResults"></pagination>
    </div>
</template>

<script>
    import RequestHistoryLogItem from "./RequestHistoryLogItem";
    export default {
        components: {RequestHistoryLogItem},
        props: ['request_id'],
        name: "RequestHistoryLogs",
        data: () => ({
            logs: {},
            current_page: 1,
        }),
        mounted() {
            this.getResults();
            let self = this;
            this.$bus.$on([
                'request:saved',
                'request.' + this.request_id + '.comment:create',
                'request.' + this.request_id + '.sms_message:create',
                'request.' + this.request_id + '.reminder:create',
                'request.' + this.request_id + '.reminder:done',
            ], function () {
                self.getResults();
            });
        },
        beforeDestroy: function() {
            this.$bus.$off([
                'request:saved',
                'request.' + this.request_id + '.comment:create',
                'request.' + this.request_id + '.sms_message:create',
                'request.' + this.request_id + '.reminder:create',
                'request.' + this.request_id + '.reminder:done',
            ]);
        },
        methods: {
            getResults(page = 1) {
                this.current_page = page;
                axios.get('/api/requests/' + this.request_id + '/logs?page=' + page)
                    .then(response => {
                        this.logs = response.data;
                    });
            }
        }
    }
</script>

<style scoped>

</style>
